/**
 * @Author Heriberto Monterrubio <heri185403@gmail.com>
 * @Date 2020-Sep-17
 *
 **/
 import Vue from "vue"
 import VueRouter from "vue-router"
 import Constants from "bestgob-core/core/constants";
 import * as Storage from 'bestgob-core/core/storage.js'
 
 
 Vue.use(VueRouter)
 
 
 const routes = [
    {
        // will match everything
        path: '*',
        component: () => import('../views/Login')

    },
    {
        path: '/home',
        name: 'home',
        //meta: {title: 'Home'},
        meta: {
            requiresAuth: true
        },
        component: () => import('../views/Dashboard')
    },
    {
        path: '/',
        name: 'landing',
        //meta: {title: 'Home'},
        component: () => import('./../views/LandingPage')
    },
    {
        path: '/login',
        name: 'login',
        meta: {title: 'Iniciar Sesión'},
        component: () => import('../views/Login')
    },
    {
        path: '/forgot_password',
        name: 'forgot_password',
        meta: {title: 'Recuperar contraseña'},
        component: () => import('../views/ForgotPassword')
    },
    {
        path: '/forgot_password_email',
        name: 'forgot_password_email',
        meta: {title: 'Recuperar contraseña'},
        component: () => import('./../views/ForgotPasswordEmail')
    },

    {
        path: '/register',
        name: 'register',
        meta: {title: 'Registrarme'},
        component: () => import('../views/Register')
    },
    {
        path: '/documents/validate',
        name: 'documents_validate',
        meta: {title: 'Validar documento'},
        component: () => import('../views/DocumentValidation')
    },
    {
        path: '/paid/validate',
        name: 'paid_validate',
        meta: {title: 'Validar pago'},
        component: () => import('../views/PaidValidation')
    },
    {
        path: '/user-profile',
        name: 'user_profile',
        meta: {title: 'User profile', requiresAuth: true},
        component: () => import('../views/UserProfile')
    },
    {
        path: '/password-update',
        name: 'password_update',
        meta: {title: 'Password update', requiresAuth: true},
        component: () => import('../views/PasswordUpdate')
    },
    {
        path: '/processes',
        name: 'processes',
        meta: {title: 'Lista de procesos'},
        component: () => import('../views/Processes')
    },
    {
        path: '/processes/:processId/requirements/:processName',
        name: 'process_requirement',
        meta: {title: 'Requerimientos del proceso'},
        component: () => import('../views/ProcessRequirements')
    },
    {
        path: '/procedures/create/:processId',
        name: 'procedure_create',
        meta: {title: 'Iniciar trámite', },
        component: () => import('../views/ProcedureCreate')
    },
    {
        path: '/procedures/continue/:stageId',
        name: 'procedure_continue',
        meta: {title: 'Continuar trámite'},
        component: () => import('../views/ProcedureCreate')
    },
    {
        path: '/procedures/view/:stageId',
        name: 'procedure_view',
        meta: {title: 'Continuar trámite'},
        component: () => import('../views/ProcedureCreate')
    },
    {
        path: '/procedures/execute/:processId',
        name: 'procedure_execute',
        meta: {title: 'Continuar trámite'},
        component: () => import('../views/ProcedureExecute')
    },
    {
        path: '/portfolio/:step',
        name: 'portfolio',
        meta: {title: 'Porfafolio de trámites', requiresAuth: true},
        component: () => import('../views/Portfolio')
    },
    {
        path: '/orders/:action/',
        name: 'orders',
        meta: {title: 'Lista de órdenes', requiresAuth: true},
        component: () => import('../views/Orders')
    },
    {
        path: '/orders/:action/:id',
        name: 'orders_details',
        meta: {title: 'Lista de órdenes', requiresAuth: true},
        component: () => import('../views/Orders')
    }
]


const router = new VueRouter({
    mode: "history",
    routes: routes
})


router.beforeEach((to, from, next) => {
    let user = Storage.getItem(Constants.KEY_USER);
    if (to.matched.some(record => record.meta.requiresAuth)) {
      // this route requires auth, check if logged in
      // if not, redirect to login page.
      if (!user) {
        router.push({ name: 'landing' }).catch(error=>{
            console.log(error);
        })
        

      } else {
        next() // go to wherever I'm going
      }
    } else{
      next() // does not require auth, make sure to always call next()!
    }
});


export default routes

